import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useInputWrapperContext } from "./auth-service-tools304.js";
import { usePillsInputContext } from "./auth-service-tools384.js";
import classes from "./auth-service-tools390.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  type: "visible"
};
const PillsInputField = factory((_props, ref) => {
  const props = useProps("PillsInputField", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    type,
    disabled,
    id,
    pointer,
    mod,
    ...others
  } = props;
  const ctx = usePillsInputContext();
  const inputWrapperCtx = useInputWrapperContext();
  const getStyles = useStyles({
    name: "PillsInputField",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    rootSelector: "field"
  });

  const _disabled = disabled || (ctx == null ? void 0 : ctx.disabled);

  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    component: "input",
    ref: useMergedRef(ref, ctx == null ? void 0 : ctx.fieldRef),
    "data-type": type,
    disabled: _disabled,
    mod: [{
      disabled: _disabled,
      pointer
    }, mod],
    ...getStyles("field"),
    ...others,
    id: (inputWrapperCtx == null ? void 0 : inputWrapperCtx.inputId) || id,
    "aria-invalid": ctx == null ? void 0 : ctx.hasError,
    "aria-describedby": inputWrapperCtx == null ? void 0 : inputWrapperCtx.describedBy,
    type: "text",
    onMouseDown: event => !pointer && event.stopPropagation()
  });
});
PillsInputField.classes = classes;
PillsInputField.displayName = "@mantine/core/PillsInputField";
export { PillsInputField };